const map = {
	"./add.svg": 75919,
	"./banco-do-brasil.svg": 2783,
	"./bradesco.svg": 96083,
	"./caixa.svg": 63362,
	"./inter.svg": 45660,
	"./itau.svg": 38987,
	"./nubank.svg": 41548,
	"./remove.svg": 9406,
	"./santander.svg": 9814,
	"./sync.svg": 63167
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46232;